import { Component } from '@angular/core';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';

@Component({
  selector: 'app-four-tax-warning',
  templateUrl: './four-tax-warning.component.html',
  styleUrls: ['./four-tax-warning.component.scss'],
})
export class FourTaxWarningComponent {
  iamgeURL = 'assets/images/AF_farol_roxo.svg';

  constructor(
    private headerService: HeaderService,
    public copyService: CopyService,
    private navigationService: NavigationService,

  ) {
    this.headerService.show();
  }

  next() {
    this.navigationService.goToLoginPage();
  }

}
